<div class="card-wrapper" [title]="data.title" (click)="onClick()" [class.selected]="isSelected" [class.active]="isActive">
  <div class="top-section flex justify-between items-center" [id]="data.uri">
    <div class="date label-xs-single">{{ data.date | date : 'mediumDate' }}</div>
  </div>
  <div class="content-section mt-2 title-sm">{{ data.title }}</div>
</div>
